import React from 'react';
import { Flex, Box } from '@marvelapp/ui';
import { SpecsPanel } from '@marvelapp/ui-internal';
import PanelSwatch from './PanelSwatch';
export default function PanelColours(_a) {
    var solidCols = _a.solidCols, opacityCols = _a.opacityCols;
    return (React.createElement(SpecsPanel, { title: "Document Colours" },
        React.createElement(Flex, { flexWrap: "wrap", marginLeft: "-4px", width: "calc(100% + 6px)" },
            solidCols.map(function (color) { return (React.createElement(Box, { key: color, padding: "4px", width: 1 / 9 },
                React.createElement(PanelSwatch, { color: color }))); }),
            opacityCols.map(function (color) { return (React.createElement(Box, { key: color, padding: "4px", width: 1 / 9 },
                React.createElement(PanelSwatch, { color: color }))); }))));
}
